import React from "react";
import PopoverMenu from "../../../design-system-components/PopoverMenu/PopoverMenu";
import { Icon } from "@evidenceb/athena-common/design-system/Icon";
import { defineMessages, useIntl } from "react-intl";
import AccessibleButton from "../../AccessibleButton/AccessibleButton";
import { commonMessages } from "../../../utils/messages";
import AddStudentsModal from "../../../pages/DashBoard/DashboardTeacher/Classroom/Details/AddStudentsModal/AddStudentsModal";
import { useOverlayTriggerState } from "react-stately";
import { Classroom } from "../../../interfaces/User";

import "./ModifyStudentsSettings.scss";

interface Props {
    classroom: Classroom;
}

const ModifyStudentsSettings = ({ classroom }: Props) => {
    const intl = useIntl();

    const addStudentsModal = useOverlayTriggerState({});

    const popoverMenuHandler = async (key: React.Key) => {
        if (key === "add") {
            addStudentsModal.open();
        }
    };

    return (
        <>
            <PopoverMenu
                className="modify-students-settings"
                trigger={
                    <AccessibleButton className="modify-students-settings__trigger">
                        {intl.formatMessage(commonMessages.modify)}
                        <Icon path="chevron_down" size="medium" />
                    </AccessibleButton>
                }
                popoverPlacement="bottom end"
                onAction={popoverMenuHandler}
            >
                <PopoverMenu.Item
                    key="add"
                    textValue={intl.formatMessage(messages.addStudents)}
                >
                    <button onClick={() => addStudentsModal.open()}>
                        <Icon
                            path="user-add-outlined"
                            color={"var(--text-main-default)"}
                            size="medium"
                        />
                        {intl.formatMessage(messages.addStudents)}
                    </button>
                </PopoverMenu.Item>
            </PopoverMenu>

            {addStudentsModal.isOpen && (
                <AddStudentsModal
                    classroom={classroom}
                    onEnd={() => {
                        addStudentsModal.close();
                    }}
                    onCancel={() => addStudentsModal.close()}
                    state={addStudentsModal}
                />
            )}
        </>
    );
};
export default ModifyStudentsSettings;

const messages = defineMessages({
    addStudents: {
        id: "classroom-details-addStudents",
        defaultMessage: "Add students",
    },
});
